import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar';
import PageTitle from '../../components/pagetitle'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo.png'
import Service7 from '../../components/Service7';

const Education =() => {
    return(
        <Fragment>
            <Navbar Logo={Logo}/>
            <PageTitle pageTitle={'Education'} pagesub={'Education'}/> 
            <Service7/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default Education;

